<div class="header space-v-xl">
  <h2 class="header-title">{{ 'COPY_RECIPES_MARKET.MODAL.TITLE' | translate }}</h2>
  <div class="header-button">
    <button class="space-h-s btn-warn" mat-raised-button (click)="reset()">
      <span class="fa fa-times space-h-s"></span>{{ 'CANCEL' | translate }}
    </button>
    <button
      class="space-h-s btn-submit"
      mat-raised-button
      [disabled]="!formImport.valid || fileErrorExtension || fileErrorFormat"
      (click)="submit()"
    >
      {{ 'COPY_RECIPES.MODAL.BTN_COPY' | translate }}<span class="fa fa-arrow-circle-right space-l-s"></span>
    </button>
  </div>
</div>

<div class="content">
  <form [formGroup]="formImport" class="row">
    <mat-card class="form-card">
      <mat-card-header class="form-card-header">
        {{ 'COPY_RECIPES_MARKET.MODAL.SOURCE' | translate }}
      </mat-card-header>
      <mat-card-content class="form-card-content">
        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
          <mat-select formControlName="sourceDomain" (selectionChange)="updateDomain($event.value)" required>
            <mat-option *ngFor="let current of domains | sortBy : 'translatedName'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'MARKET' | translate }}</mat-label>
          <mat-select formControlName="sourceMarket" (selectionChange)="updateLang($event.value, true)" required>
            <mat-option *ngFor="let current of markets | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'LANG' | translate }}</mat-label>
          <mat-select formControlName="sourceLang" required>
            <mat-option *ngFor="let current of languagesFilteredSources | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-label>{{ 'COPY_RECIPES_MARKET.FILE_TITLE' | translate }} *</mat-label>
        <button type="button" class="btn-submit" mat-raised-button (click)="fileInput.click()">
          <div *ngIf="!fileName">{{ 'COPY_RECIPES_MARKET.BTN_FILE' | translate }}</div>
          <div *ngIf="fileName">{{ fileName }}</div>
        </button>
        <input hidden (change)="onFileSelected(fileInput)" #fileInput type="file" id="file" />
        <mat-error *ngIf="fileErrorExtension">{{ 'COPY_RECIPES_MARKET.ERROR_EXTENSION' | translate }}</mat-error>
        <mat-error *ngIf="fileErrorFormat">{{ 'COPY_RECIPES_MARKET.ERROR_FORMAT' | translate }}</mat-error>
        <mat-hint class="hint">{{ 'COPY_RECIPES_MARKET.HINT' | translate }}</mat-hint>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-card">
      <mat-card-header class="form-card-header">
        {{ 'COPY_RECIPES_MARKET.MODAL.TARGET' | translate }}
      </mat-card-header>
      <mat-card-content class="form-card-content">
        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'DOMAIN' | translate }}</mat-label>
          <mat-select formControlName="targetDomain" [disabled]="true" required>
            <mat-option *ngFor="let current of domains | sortBy : 'translatedName'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'MARKET' | translate }}</mat-label>
          <mat-select formControlName="targetMarket" (selectionChange)="updateLang($event.value, false)" required>
            <mat-option *ngFor="let current of markets | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="mat-form-field" appearance="fill">
          <mat-label>{{ 'LANG' | translate }}</mat-label>
          <mat-select formControlName="targetLang" required>
            <mat-option *ngFor="let current of languagesFilteredTarget | sortBy : 'translatedName' : 'ASC'" [value]="current.key">
              {{ current.translatedName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="resume form-card" *ngIf="formImport.controls.targetLang.value && formImport.controls.ids.value?.length">
      <mat-card-header class="form-card-header">
        {{ 'COPY_RECIPES_MARKET.RESUME' | translate }}
      </mat-card-header>
      <mat-card-content class="form-card-content">
        <span class="space-t-xl">
          {{ 'COPY_RECIPES_MARKET.TARGET_MARKET' | translate }} : {{ getName(formImport.controls.targetMarket.value, markets) }}
        </span>
        <span class="space-t-xl">
          {{ 'COPY_RECIPES_MARKET.TARGET_LANG' | translate }} : {{ getName(formImport.controls.targetLang.value, languagesFilteredTarget) }}
        </span>
        <span class="space-t-xl"> {{ 'COPY_RECIPES_MARKET.NB_RECIPES' | translate }} : {{ formImport.controls.ids.value?.length }} </span>
      </mat-card-content>
    </mat-card>
  </form>
</div>
